import useUrl from './helpers/useUrl'

/** @param {import('@nuxtjs/axios').NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('tickets')
  return {
    // WARN: Not found usages at all
    userTicketsList() {
      const url = root('list-user')
      return client.get(url)
    },
  }
}
